import { useState } from "react"

export const useMultistepForm = (steps) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0)

  const next = () => {
    setCurrentStepIndex(index => {
      if (index >= steps.length - 1) return index
      return index + 1
    })
  }
  const goForwardTwoSteps = () => {
    next(next());
  }

  const back = () => {
    setCurrentStepIndex(index => {
      if (index <= 0) return index
      return index - 1
    })
  }
  const goBackTwoSteps = () => {
    back(back());
  }

  const goTo = (index) => {
    setCurrentStepIndex(index)
  }

  return {
    currentStepIndex,
    currentProgressPercentage: Math.round((((currentStepIndex + 1) / steps.length) * 100)),
    currentStepComponent: steps[currentStepIndex],
    steps,
    isFirstStep: currentStepIndex === 0,
    isLastStep: currentStepIndex === steps.length - 1,
    goTo,
    goForwardTwoSteps,
    goBackTwoSteps,
    next,
    back,
  }
}